import {
  enumListAsRecordObject,
  lookupListAsRecordObject
} from '@utils/graph-utils';

import { IPersonDetailsInfo } from '..';
import { IPersonAdditionalInformationInfo } from '.';

export function LookupToList(data: any) {
  const additionalInfoEnums: Record<string, Record<string, string>> = {};

  additionalInfoEnums['genders'] = enumListAsRecordObject(
    data?.Gender?.enumValues as {
      __typename: string;
      name: string;
    }[]
  );
  additionalInfoEnums['maritalStatuses'] = enumListAsRecordObject(
    data?.MaterialStatus?.enumValues as {
      __typename: string;
      name: string;
    }[]
  );

  additionalInfoEnums['countries'] = lookupListAsRecordObject(
    data.core.getCountries
  );

  additionalInfoEnums['nationalities'] = lookupListAsRecordObject(
    data.core.getNationalities
  );

  return additionalInfoEnums;
}

export function graphqlEntityToAdditionalInfo(
  additionalInfo: IPersonDetailsInfo
): IPersonAdditionalInformationInfo {
  return {
    gender: additionalInfo?.gender,
    maritalStatus: additionalInfo?.maritalStatus,
    spouseFullName: additionalInfo?.spouseFullName,
    spouseProfession: additionalInfo?.spouseProfession,
    fatherName: additionalInfo?.fatherName,
    motherName: additionalInfo?.motherName,
    countryOfBirth: additionalInfo?.countryOfBirth,
    cityOfBirth: additionalInfo?.cityOfBirth,
    civilRegisterPlace: additionalInfo?.civilRegisterPlace,
    civilRegisterNumber: additionalInfo?.civilRegisterNumber,
    nationalityID: additionalInfo?.nationalityId,
    passportNumber: additionalInfo?.passportNumber,
    secondNationality: additionalInfo?.secondNationality?.id
  };
}
